import { Component } from '@angular/core';
import { BaseComponent } from 'src/app/core/base.component';
import { OutingService } from 'src/app/outing/outing.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { OutingList } from '../models/outing.list';
import { MatDialogRef } from '@angular/material/dialog';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

@Component({
    selector: 'outing-edit-modal',
    templateUrl: './outing-edit-modal.component.html',
    styleUrls: ['./outing-edit-modal.component.scss'],
    standalone: false
})
export class OutingEditModalComponent extends BaseComponent {
  public outing: OutingList;

  constructor(sessionService: SessionService,
    public diaglogRef: MatDialogRef<OutingEditModalComponent>,
    private outingService: OutingService,
    stringHelpers: StringHelpers) {
    super(sessionService, stringHelpers);
  }

  submit(){
    this.isLoading = true;
    let data = {
      id: this.outing.id,
      name: this.outing.name,
      lastEditedBy: this.sessionService.getUserId()
    };
    this.outingService.update(data).subscribe({
      next: () => this.isLoading = false,
      error: (error) => console.error(error),
      complete: () => this.diaglogRef.close()
    });
  }
}
